import IWall from 'components/interfaces/IWall';
import store from 'store/store';
import { setWall } from 'store/selectedWall/actions';

import {
  GLASS_TYPE_1076,
  GLASS_TYPE_1276,
  GLASS_TYPE_4152,
} from 'components/configurator/types/glassTypes';

import {
  is2kAluGlazy,
  isSlidy30,
  isSlidy36,
  isWoodyTypeWall,
} from 'components/configurator/types/glazingWallTypesCheck';

import {
  SE0004 as ROOF_PROFILE_SE0004,
  SE0005 as ROOF_PROFILE_SE0005,
  SE0184 as ROOF_PROFILE_SE0184,
  SE0204 as ROOF_PROFILE_SE0204,
} from 'components/configurator/types/roofProfileTypes';

import {
  SE0204 as FLOOR_PROFILE_SE0204,
  SE0134 as FLOOR_PROFILE_SE0134,
} from 'components/configurator/types/floorProfileTypes';

const updateGlazingWallTypeDependencies = (wall: IWall | null): void => {
  if (wall === null) {
    return;
  }

  const wallCopy = { ...wall };

  if (is2kAluGlazy(wallCopy)) {
    wallCopy.aluGlazyFloorProfileType = FLOOR_PROFILE_SE0204;
    wallCopy.aluGlazyRoofProfileType = ROOF_PROFILE_SE0204;
    wallCopy.glassType = GLASS_TYPE_4152;
  }

  if (isSlidy30(wallCopy)) {
    wallCopy.aluGlazyFloorProfileType = FLOOR_PROFILE_SE0134;
    wallCopy.aluGlazyRoofProfileType = ROOF_PROFILE_SE0004;
    wallCopy.glassType = GLASS_TYPE_1076; // preset value:  5+5 075 SC
    wallCopy.positionOffset = 0;

    if (wall.thickness >= 90) {
      wallCopy.aluGlazyRoofProfileType = ROOF_PROFILE_SE0005;
    }
  }

  if (isSlidy36(wallCopy)) {
    wallCopy.aluGlazyFloorProfileType = FLOOR_PROFILE_SE0134;
    wallCopy.aluGlazyRoofProfileType = ROOF_PROFILE_SE0184;
    wallCopy.glassType = GLASS_TYPE_1276; // preset value: 6+6 075 SC
    wallCopy.positionOffset = 0;
  }

  if (isWoodyTypeWall(wallCopy)) {
    wallCopy.woodyDoorFrameColor = 'RAL 9003';
    wallCopy.woodyDoorLeafColor = 'RAL 9003';
  } else {
    wallCopy.woodyDoorFrameColor = '';
    wallCopy.woodyDoorLeafColor = '';
  }

  store.dispatch(setWall(wallCopy));
};

export default updateGlazingWallTypeDependencies;
